import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// ActivityStore：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class ActivityStore {
    @observable namespace = 'activity';

    @observable activityList = null;
    @observable activityFavoriteList = null;
    @observable activityData = null; // 活动详情数据

    constructor(initData = {}) {
        this.listStore = new ListStore();
        // 注册业务list
        this.listStore.registerList({ namespace: 'activityList' });
        this.listStore.registerList({ namespace: 'activityFavoriteList' });
        this.listStore.registerList({ namespace: 'activityPostList' }); // 活动评论列表
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.activityList) {
            this.listStore.lists['activityList'].data = initData.activityList;
        }
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get activityListData() {
        return this.listStore.getList({ namespace: 'activityList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get activityListAttribs() {
        return this.listStore.lists['activityList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get activityListLoading() {
        return this.listStore.lists['activityList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get activityListError() {
        return this.listStore.lists['activityList']?.requestError || { isError: false, errorText: '' };
    }


    /**
     * 获取用户收藏活动列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get activityFavoriteListData() {
        return this.listStore.getList({ namespace: 'activityFavoriteList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get activityFavoriteListAttribs() {
        return this.listStore.lists['activityFavoriteList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get activityFavoriteListLoading() {
        return this.listStore.lists['activityFavoriteList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get activityFavoriteListError() {
        return this.listStore.lists['activityFavoriteList']?.requestError || { isError: false, errorText: '' };
    }
}

// 不再导出 Store 实例，全部用 Action 实例